export default __webpack_public_path__ + "static/media/recording.898fe8fc.svg";